<template>
  <div class="modules">
    <template v-if="connected">
      <SaddleModule
        v-show="hasFitbike && hasPositioningMotors"
        class="modules__item"
      />
      <HandlebarModule
        v-show="hasFitbike && hasPositioningMotors"
        class="modules__item"
      />
      <XYToolModule
        v-if="hasXYTool"
        class="modules__item"
      />
      <ResistanceModule class="modules__item" />
      <HeartrateModule
        v-if="hasHeartRateMonitor"
        class="modules__item"
      />
      <PedallingAnalyzerModule
        v-if="has3DPedallingAnalyzer"
        class="modules__item"
      />
      <MotionAnalyzerModule
        v-if="has3DMotionAnalyzer"
        class="modules__item"
      />
    </template>

    <empty-module
      v-else
      class="modules__item"
    />
  </div>
</template>

<script setup lang="ts">
import PedallingAnalyzerModule from '@/components/controls/modules/PedallingAnalyzerModule.vue'
import HeartrateModule from '@/components/controls/modules/HeartrateModule.vue'
import SaddleModule from '@/components/controls/modules/SaddleModule.vue'
import HandlebarModule from '@/components/controls/modules/HandlebarModule.vue'
import ResistanceModule from '@/components/controls/modules/ResistanceModule.vue'
import XYToolModule from '@/components/controls/modules/XYToolModule.vue'
import EmptyModule from '@/components/controls/modules/EmptyModule.vue'
import MotionAnalyzerModule from '@/components/controls/modules/MotionAnalyzerModule.vue'
import { useMqttStore } from '@/store/mqttStore'
import { usePreferenceStore } from '@/store/preferenceStore'
import { storeToRefs } from 'pinia'

const mqttStore = useMqttStore()
const preferenceStore = usePreferenceStore()

const { connected } = storeToRefs(mqttStore)
const {
  hasFitbike,
  hasPositioningMotors,
  hasXYTool,
  has3DMotionAnalyzer,
  has3DPedallingAnalyzer,
  hasHeartRateMonitor,
} = storeToRefs(preferenceStore)
</script>

<style lang="scss">
.modules {
  display: flex;
  gap: 1.6rem;
  padding: 1.6rem;
  height: 32rem;
  overflow-x: auto;
  width: 100%;

  &__item {
    width: 24%;
    min-width: 24%; // is flex-item if `connected` is true, min-width so flex-box parent overflows
  }
}
</style>
